import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IdleTimer from 'react-idle-timer';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';

import { Button } from 'shared/components';
import { VideoSidebarLayout } from 'modules/queues/Schedule/containers';
import { AppointmentsSidebarLayout } from 'modules/queues/common/containers';
import PermissionsPrompt from 'modules/notifications/components/PermissionsPrompt';

import theme from './ScheduleConferencePage.scss';

class ScheduleConferencePage extends Component {
  static propTypes = {
    handleIdle: PropTypes.func,
    appointment: PropTypes.object,
    intl: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
    idleTime: PropTypes.number.isRequired,
    isInStandaloneMode: PropTypes.bool.isRequired,
    isAppointmentFetching: PropTypes.bool.isRequired,
    isConferenceInProgress: PropTypes.bool.isRequired,
    isAppointmentInfoShown: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    handleIdle: () => {},
    appointment: {},
  };

  state = {
    activeSide: 'videoContainer',
    touchStartX: 0,
    touchEndX: 0,
  };

  componentDidMount() {
    window.intl = this.props.intl;
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.isAppointmentInfoShown && !this.props.isAppointmentInfoShown) ||
      (prevProps.appointment.appointmentId !== this.props.appointment.appointmentId) ||
      (prevProps.isConferenceInProgress !== this.props.isConferenceInProgress)
    ) {
      this.setState({ activeSide: 'videoContainer' });
    }
  }

  handleTouchStart = (e) => this.setState({ touchStartX: e.touches[0].clientX });

  handleTouchEnd = (e) => this.setState({ touchEndX: e.changedTouches[0].clientX }, this.handleSwipe);

  handleSwipe = () => {
    const { touchStartX, touchEndX, activeSide } = this.state;
    const { isMobile, isAppointmentInfoShown } = this.props;

    if (!isMobile || !isAppointmentInfoShown) return;

    const swipeDistance = touchStartX - touchEndX;
    const swipeThreshold = 50;

    if (swipeDistance > swipeThreshold && activeSide === 'sidebarContainer') {
      this.setActiveSide('videoContainer');
    } else if (swipeDistance < -swipeThreshold && activeSide === 'videoContainer') {
      this.setActiveSide('sidebarContainer');
    }
  };

  setActiveSide = (activeSide) => this.setState({ activeSide });

  render() {
    const {
      idleTime,
      isMobile,
      handleIdle,
      isInStandaloneMode,
      isAppointmentFetching,
      appointment: { isF2F },
      isAppointmentInfoShown,
    } = this.props;

    const { activeSide } = this.state;

    return (
      <>
        <div
          className={ classnames(theme.root, { [theme.active]: isAppointmentInfoShown && activeSide === 'videoContainer' }) }
          id="rootPage"
          onTouchStart={ this.handleTouchStart }
          onTouchEnd={ this.handleTouchEnd }
        >
          <div
            className={ classnames(theme.sidebarContainer, {
              [theme.detailsShown]: isAppointmentInfoShown,
              [theme.detailsMobileLayout]: isAppointmentInfoShown,
            }) }
          >
            <AppointmentsSidebarLayout />
          </div>
          <div
            className={ classnames(theme.videoContainer, {
              [theme.videoPlaceholderContainer]: !isAppointmentInfoShown,
              [theme.detailsMobileLayout]: isAppointmentInfoShown,
              [theme.hidden]: isAppointmentFetching,
            }) }
          >
            <VideoSidebarLayout isNeedToShowBackButton={ isAppointmentInfoShown && activeSide === 'videoContainer' } />
          </div>

          <IdleTimer
            element={ document }
            idleAction={ handleIdle }
            timeout={ idleTime }
          />
          <If condition={ isMobile && isInStandaloneMode }>
            <PermissionsPrompt />
          </If>
        </div>

        <If condition={ !isAppointmentFetching }>
          <div className={ classnames(theme.tapIcon, { [theme.detailsMobileLayout]: isAppointmentInfoShown }) }>
            <Button
              iconName="appointment_exclamation_mark"
              size="small"
              className={ classnames(theme.videoContainerButton, { [theme.activeButton]: activeSide === 'sidebarContainer' }) }
              onClick={ () => this.setActiveSide('sidebarContainer') }
            />

            <Button
              iconName="answer"
              size="small"
              onClick={ () => this.setActiveSide('videoContainer') }
              className={
                classnames(theme.sidebarContainerButton, { [theme.activeButton]: activeSide !== 'sidebarContainer' }) }
            />
          </div>
        </If>
      </>
    );
  }
}

export default injectIntl(ScheduleConferencePage);
